import { sendGAEvent } from '../utils';

export enum WelcomeEvents {
  WELCOME_MODAL_APPEARANCE = 'welcome_modal_appearance',
  WELCOME_MODAL_PROCEED = 'welcome_modal_proceed',
  WELCOME_MODAL_CLOSE = 'welcome_modal_close',
}

const WELCOME_CATEGORY = 'welcome';

/**
 * @description Appearance of the welcome modal.
 */
export const sendWelcomeModalAppearanceEvent = () => {
  sendGAEvent(WelcomeEvents.WELCOME_MODAL_APPEARANCE, {
    event_category: WELCOME_CATEGORY,
  });
};

/**
 * @description Click on "Deposit and Luck Up" of the welcome modal.
 */
export const sendWelcomeModalProceedEvent = () => {
  sendGAEvent(WelcomeEvents.WELCOME_MODAL_PROCEED, {
    event_category: WELCOME_CATEGORY,
  });
};

/**
 * @description Click on the cross icon of the welcome modal.
 */
export const sendWelcomeModalCloseEvent = () => {
  sendGAEvent(WelcomeEvents.WELCOME_MODAL_CLOSE, {
    event_category: WELCOME_CATEGORY,
  });
};
